import { z } from 'zod';
import {
  numberRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { benefitCategories } from 'store/benefits';
import { shopItemCategories } from 'types/MarketplaceItems';
import {
  shopItemsByBenefitListVariants,
  taxExemptionStatuses,
} from './shop.types';

const listVariantSchema = z.object({
  listVariant: z.enum(shopItemsByBenefitListVariants).catch('all'),
});

export const shopItemsFiltersSchema = z
  .object({
    name: z.string().catch(''),
    price: numberRangeSchema,
    items: z.array(z.string()).catch([]),
    countries: z.array(z.string()).catch([]),
    cities: z.array(z.string()).catch([]),
    suppliers: z
      .object({
        value: z.array(z.string()).catch([]),
        isInverted: z
          .string()
          .transform((v) => (v.toLowerCase() === 'true' ? true : false))
          .catch(false),
      })
      .catch({ value: [], isInverted: false }),
    benefitCategories: z.array(z.enum(benefitCategories)).catch([]),
    categories: z.array(z.enum(shopItemCategories)).catch([]),
    invertedFilters: z.array(z.string()).catch([]),
    isSelected: z.boolean().catch(false),
    taxExemptionStatus: z.array(z.enum(taxExemptionStatuses)).catch([]),
    taxExemptionCountries: z.array(z.string()).catch([]),
  })
  .merge(listVariantSchema)
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);

export const shopItemsByBenefitFiltersSchema = z
  .object({})
  .merge(shopItemsFiltersSchema)
  .merge(listVariantSchema);
